// socket.ts
import { io } from "socket.io-client";

const currentUser = localStorage.getItem("frayoChefPortal");
const parsedUser = currentUser ? JSON.parse(currentUser) : null;

// Chef UUID FROM LOCAL STORAGE
const chefUUID = parsedUser?.uuid || "";

const socket = io(process.env.REACT_APP_SOCKET_URL, {
  autoConnect: true,
});

socket.on("connect", () => {
  console.log("✅ Socket Connected:", socket.id);

  // ⭐ REGISTER CHEF TO BACKEND SOCKET
  if (chefUUID) {
    socket.emit("register", { uuid: chefUUID, type: "chef" });
    console.log("📡 Register event sent:", chefUUID);
    
  } else {
    console.warn("⚠️ chefUUID not found in localStorage");
  }
  
});
(window as any).socket = socket;
export default socket;
